import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditAliasModalComponent } from 'src/app/modals/edit-alias-modal/edit-alias-modal.component';
import { ActionService } from 'src/app/core/services/action.service';
import { toExcelFormat } from '../../../helpers/format-position';
import { ActionsEnum } from 'src/app/core/data-sources/action-data-source.service';
import { PigeonholeService } from 'src/app/core/data-sources/v3/pigeonhole/pigeonhole.service';
import { PigeonholeMapPosition, PigeonholePositionInfo } from 'src/models/Pigeonhole';
import { GroundPositionState, GroundPositionStateOptions } from 'src/models/GroundPosition';
import { translateGroundPositionType, translateGroundPositionState } from 'src/app/helpers/format-ground-position-type';

@Component({
  selector: 'app-warehouse-map-details',
  templateUrl: './warehouse-map-details.component.html',
  styleUrls: ['./warehouse-map-details.component.scss']
})
export class WarehouseMapDetailsComponent implements OnChanges {
  @Input() positionId: string;
  @Output() close = new EventEmitter<void>();
  title = 'Posição';
  positionInfo: PigeonholePositionInfo | null = null;
  stateEnum = GroundPositionState;
  positions: PigeonholeMapPosition[] = [];

  constructor(
    private pigeonholeService: PigeonholeService,
    private dialog: MatDialog,
    private actionService: ActionService
  ) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.positionId && changes.positionId.currentValue) {
      this.positionId = changes.positionId.currentValue;
      await this.getPositions();
      await this.getPositionInfo();
    }
  }

  async getPositions() {
    this.positions = await this.pigeonholeService.getPigeonholePositionMap(this.positionId);
  }

  async getPositionInfo() {
    this.positionInfo = await this.pigeonholeService.getPigeonholePositionInfo(this.positionId);
    this.title = this.positionInfo && this.positionInfo.alias
      ? `Posição ${this.positionInfo.alias}`
      : `Posição ${toExcelFormat(this.positionInfo.x, this.positionInfo.y)}`;
  }

  formatPosition(x, y) {
    return toExcelFormat(x, y);
  }

  markQRCodeToBeChanged(position) {
    this.actionService.changePigeonholeState({
      pigeonholeId: position.id,
      action: GroundPositionStateOptions.MARK_TO_REPLACE_QR_CODE
    }).then(() => {
      this.getPositions();
    });
  }

  markQRCodeToAsReady(position) {
    this.actionService.changePigeonholeState({
      pigeonholeId: position.id,
      action: GroundPositionStateOptions.READY
    }).then(() => {
      this.getPositions();
    });
  }

  editAlias(position) {
    const dialogRef = this.dialog.open(EditAliasModalComponent, {
      panelClass: 'confirm-modal',
      data: position
    });
    dialogRef.afterClosed().subscribe(async pos => {
      if (pos) {
        await this.actionService.editPigeonholeAlias({
          type: ActionsEnum.EDIT_PIGEONHOLE_ALIAS,
          data: {
            pigeonholeId: pos.id,
            alias: pos.alias
          }
        });
      }
    });
  }

  translateType(type) {
    return translateGroundPositionType(type);
  }

  translateState(state) {
    return translateGroundPositionState(state);
  }

  onToggleChange(event, position) {
    const payload = {
      pigeonholeId: position.id,
      action: GroundPositionStateOptions.READY
    };
    if (event.checked) {
      payload.action = GroundPositionStateOptions.BLOCK;
    }
    this.actionService.changePigeonholeState(payload).then(() => {
      this.getPositions();
    });
  }

  returnToTable() {
    this.close.emit();
  }
}
